<template>
  <WhitePage :loading="$store.getters.loading">
    <title-bar>管理コマンド</title-bar>
    <!-- <setting-nav></setting-nav> -->
    <b-card title="更新">
      <b-card-text>
        手動で更新処理を行います。
      </b-card-text>
      <b-form-group label="更新">
        <template #description>
          <s>更新して一日分ゲーム内時間を進めます。</s>現在封鎖しています。復旧までまったりお待ちください。
          <b-alert show variant="warning">
            更新ボタンを押してから成功通知の後、裏で更新処理が始まります。更新が反映されるまで時間がかかります。
            <b>更新処理終了の通知はないので、更新結果をのんびり待ってください。</b>更新が終わるまで次のリクエストできません。
          </b-alert>
        </template>
        <b-button type="button" variant="primary" @click="executeDaily" disabled>更新リクエスト</b-button>
      </b-form-group>
      <b-form-group label="巻き戻し"
        description="現在の更新結果を取り消して一つ前の更新結果に戻ります。巻き戻せるのは最終更新から１回のみです。">
        ＜準備中＞
        <!-- <b-button type="button" variant="warning" @click="rollbackDaily">巻き戻し</b-button> -->
      </b-form-group>
      <response-message :value="postMessage" />
    </b-card>
  </WhitePage>
</template>

<script>
// import store from '@/store'
import WhitePage from '@/components/WhitePage'
import CheckLogin from '@/components/mixin-checkLogin'
import TitleBar from '@/components/TitleBar'
import ResponseMessage from '@/components/ResponseMessage'
// import SettingNav from '@/components/SettingNav'
// import RemarkEditor from '@/components/RemarkEditor'
export default {
  components: {
    WhitePage,
    TitleBar,
    ResponseMessage,
    // SettingNav,
    // RemarkEditor
  },
  data () {
    return {
      form: {
      },
      loading: false,
      postMessage: {}
    }
  },
  mixins: [
    CheckLogin
  ],
  methods: {
    setData (response) {
        // this.form.nickname = response.nickname
        // this.form.name = response.name
        // this.form.memo = response.memo
        // this.form.note = response.note
        // this.form.image = response.image
        this.player = response.player
    },
    executeDaily () {
      this.$store.dispatch('executeDaily', this.form)
        .then((response)=>{
          this.postMessage = response
        })
    },
    rollbackDaily () {
      this.$store.dispatch('rollbackDaily', this.form)
        .then((response)=>{
          this.postMessage = response
        })
    }
  },
  // beforeRouteEnter (route, redirect, next) {
  //   store.dispatch('getProfile', {})
  //     .then((response) => {
  //       next(vm => vm.checkService(response))        
  //     })
  // },
  created () {
    this.checkLogin()
  },
  // mounted () {
  //   phina.global.app.currentScene.exit('MainScene')
  // }
}
</script>

<style lang="scss" scoped>
// .editor {
//   width: 420px;
//   height: 100px;
// }
</style>
